import {useCallback, useLayoutEffect, useRef} from "react";
import {useAppDispatch} from "../../../hooks/redux";
import {useCarLink} from "../../board/model/useCarLink";
import {setGeneralOpen} from "../../chat/model/slice";
import {GENERAL} from "../../chat/model/types";

/**
 * Клик по системному уведомлению или треду в «Обсуждениях» с любой страницы
 * (S4.1): машина — через URL доски (`useCarLink`, лента к непрочитанному / вниз),
 * общий чат — в сторе. Колбэк стабильный — его можно отдавать в подписки сокета
 * без переподписки на каждую навигацию.
 */
export function useOpenChannel(): (channel: string) => void {
    const dispatch = useAppDispatch();
    const link = useCarLink();
    const ref = useRef(link);
    useLayoutEffect(() => {
        ref.current = link;
    });

    return useCallback(
        (channel: string) => {
            if (channel === GENERAL) {
                ref.current.closeCar();
                dispatch(setGeneralOpen(true));
            } else {
                dispatch(setGeneralOpen(false));
                ref.current.openCar(channel, {atChat: true});
            }
        },
        [dispatch],
    );
}
